/**
* title: Slider
**/
import { slider } from "./molecules/slider"

document.addEventListener('DOMContentLoaded', function () {
    slider();
});
